/**
 * @description 获取url地址的参数
 * @param url string url地址
 * @return object
 */
export const getUrlKey = (url) => {
  const params = {}
  const urls = url.split('?')
  if (urls.length > 1) {
    const arr = urls[1].split('&')
    for (let i = 0, l = arr.length; i < l; i++) {
      const a = arr[i].split('=')
      // @ts-ignore
      a[0] && (params[a[0]] = a?.[1] || '')
    }
  }
  return params
}

/**
 * @description 设置css变量
 * @param prop 变量名称
 * @param val 变量值
 * @param dom dom对象
 */
export function setCssVar(prop, val, dom = document.documentElement) {
  dom.style.setProperty(prop, val)
}
